import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=1d0ce3e8&scoped=true&"
import script from "./approval.vue?vue&type=script&lang=js&"
export * from "./approval.vue?vue&type=script&lang=js&"
import style0 from "./approval.vue?vue&type=style&index=0&id=1d0ce3e8&scoped=true&lang=css&"
import style1 from "./approval.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0ce3e8",
  null
  
)

export default component.exports